import { apiRequest } from "@portal/lib/ky/utils";
import { CreditFilters } from "@portal/store/Filters/credits/type";
import {
  CreditMemo,
  CreditMemoDetails,
} from "@portal/types/entities/credit-memo";
import { PageList } from "@portal/types/page-list";
import { RequestConfig } from "../types/common";

export async function getCreditNotesList(params: RequestConfig<CreditFilters>) {
  const { page, size, filters } = params;
  const data = await apiRequest<
    RequestConfig<CreditFilters>["filters"],
    PageList<CreditMemo, unknown>
  >({
    method: "POST",
    url: "v1/credit-memos/report",
    data: filters,
    searchParams: { page, size },
  });
  return await data.json();
}

export async function getCreditMemoDetails(params?: string) {
  const data = await apiRequest<unknown, CreditMemoDetails>({
    method: "GET",
    url: `v1/credit-memos/${params?.toString()}`,
  });
  return await data.json();
}
